var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalAtm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "666666DE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.168 5.33301H5.83464C4.35464 5.33301 3.1813 6.51967 3.1813 7.99967L3.16797 23.9997C3.16797 25.4797 4.35464 26.6663 5.83464 26.6663H27.168C28.648 26.6663 29.8346 25.4797 29.8346 23.9997V7.99967C29.8346 6.51967 28.648 5.33301 27.168 5.33301ZM15.168 22.6663H17.8346V21.333H19.168C19.9013 21.333 20.5013 20.733 20.5013 19.9997V15.9997C20.5013 15.2663 19.9013 14.6663 19.168 14.6663H15.168V13.333H20.5013V10.6663H17.8346V9.33301H15.168V10.6663H13.8346C13.1013 10.6663 12.5013 11.2663 12.5013 11.9997V15.9997C12.5013 16.733 13.1013 17.333 13.8346 17.333H17.8346V18.6663H12.5013V21.333H15.168V22.6663ZM5.83464 23.9997H27.168V7.99967H5.83464V23.9997Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalAtm);
export default __webpack_public_path__ + "static/media/local-atm.3603418e8daca68dfd02bbf90988162b.svg";
export { ForwardRef as ReactComponent };